import { createContext } from 'react';

export const BreadCrumbContext = createContext({
  model: []
});
